var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashimg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 9.667a1 1 0 0 0 1-1 .514.514 0 0 0 0-.1l1.86-1.86h.306L7.907 7.78v.053a1 1 0 1 0 2 0V7.78l2.426-2.447a1 1 0 1 0-1-1 .522.522 0 0 0 0 .1L8.927 6.84H8.82L7.667 5.667a1 1 0 0 0-2 0l-2 2a1 1 0 0 0 0 2zm9 2.667H1.333V1A.667.667 0 1 0 0 1v12a.667.667 0 0 0 .667.667h12a.667.667 0 0 0 0-1.333z",
    fill: "#696871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashimg3);
export default __webpack_public_path__ + "static/media/dashimg3.1f2b0da3.svg";
export { ForwardRef as ReactComponent };